import React, { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Header from "../../layout/header";
import { Box, Button, Stack, Typography } from "@mui/material";
import VerifiedContent from "../../components/dashboard/verified-content";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useMessaging } from "../../hooks/useMessaging";
import useResponsive from "../../hooks/useResponsive";
import { ContentMainLayout } from "../../layout/contentLayout";
import { useNavigate } from "react-router-dom";
import { PATH_ONBOARD } from "../../routes/path";
import Newsfeed from "../newsfeed";
import { useDashboardInfiniteScroll } from "../../hooks/useDashboardInfiniteScroll";
import { apiGetInfinitePosts } from "../../api/dashboard";
import { DashboardSearch } from "../../components/ui-elements/search";

const Dashboard: React.FC = () => {
  const theme = useTheme();
  const verified = useSelector((state: RootState) => state.content.verified);
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const { fetchChats } = useMessaging();

  // fetch the chat data
  useEffect(() => {
    fetchChats();
  }, []);

  const { items, sentryRef, loading, refetch, searchTerm, setSearchTerm } =
    useDashboardInfiniteScroll({
      fetchData: apiGetInfinitePosts,
      initialParams: { page: 1, page_size: 20, search: "" },
    });
  return (
    <>
      {/* Header Menu */}
      <Box
        sx={{
          background: theme.palette.background.paper,
        }}
      >
        {account_profile?.name && (
          <Header scrollContainerId={"main-scroll-container"}>
            <Box display={'flex'} alignItems={'center'} gap={2}>
              <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <Typography variant="h4" sx={{ fontWeight: 500 }}>
                  Your Community Report
                </Typography>

                <img
                  alt=""
                  src="/assets/icons/home/speaker.png"
                  width={24}
                  height={24}
                />
              </Stack>
              <DashboardSearch
                placeholder={"Search report"}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Box>
          </Header>
        )}

        {!account_profile?.name ? (
          <Newsfeed />
        ) : (
          <VerifiedContent
            items={items}
            loading={loading}
            sentryRef={sentryRef}
          />
        )}
      </Box>
    </>
  );
};

export default Dashboard;

const UnverifiedAccount = () => {
  const navigate = useNavigate();
  const handle_verify = () => {
    navigate(PATH_ONBOARD.root);
  };
  return (
    <ContentMainLayout>
      <Stack sx={{ pt: "10rem" }}>
        <Box
          sx={{
            background: "#fff",
            py: 2,
            px: 4,
            borderRadius: "16px",
            width: 550,
            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src={"/assets/icons/onboarding/caution-icon.png"}
              style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
            />
            <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
              Complete account setup
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#7991A4",
                fontWeight: 500,
                lineHeight: 1.5,
                textAlign: "center",
              }}
            >
              To access this feature, upload your valid voter's card.
              Verification helps ensure a personalised experience for all users.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "90%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              my: 3,
              mx: "auto",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{
                borderRadius: 40,
                boxShadow: "none",
              }}
              onClick={() => {}}
            >
              verify Account
            </Button>
          </Box>
        </Box>
      </Stack>
    </ContentMainLayout>
  );
};
